module.exports = __webpack_public_path__ + "static/pic9-ad38024e381f02e11282c27de638e8ed.png";